export default "__VITE_ASSET__DdQIh8AO__"